import {
  ToggleButton,
  ToggleButtonGroup,
  ToggleButtonProps,
  ToggleButtonGroupProps,
} from "@mui/material";
import { SelectionOption } from "../../../types";
import React from "react";

export type ItecToggleButtonGroupProps<TOption extends SelectionOption> = {
  options: TOption[];
  onChange: (value: number | null) => void;
  renderOption?: (value: TOption) => React.ReactNode;
  toggleButtonProps?:
    | Omit<ToggleButtonProps, "value" | "key">
    | ((value: TOption) => Omit<ToggleButtonProps, "value" | "key">);
  value: number | undefined;
} & Omit<ToggleButtonGroupProps, "onChange">;

export function ItecToggleButtonGroup<TOption extends SelectionOption>(
  props: ItecToggleButtonGroupProps<TOption>
) {
  const { options, renderOption, onChange, value, toggleButtonProps, ...rest } =
    props;

  return (
    <ToggleButtonGroup
      value={value || 0}
      exclusive={true}
      onChange={(_, newValue) => {
        onChange(newValue);
      }}
      {...rest}
    >
      {options.map((option) => (
        <ToggleButton
          value={option.value}
          key={option.value}
          {...(toggleButtonProps
            ? typeof toggleButtonProps === "function"
              ? toggleButtonProps(option)
              : toggleButtonProps
            : {})}
        >
          {renderOption ? renderOption(option) : option.label}
        </ToggleButton>
      ))}
    </ToggleButtonGroup>
  );
}
